import { PropTypes } from 'prop-types';

export const StatusIconProps = {
  width: PropTypes.string,
  height: PropTypes.string
};
